import { COMPANY, LOGO_URL } from "@/i18n/translations";

export const Logo = ({ className = "", onClick }) => {
  return (
    <button
      onClick={onClick}
      data-testid="site-logo"
      className={`group flex items-center ${className}`}
      aria-label={`${COMPANY.name} ${COMPANY.suffix}`}
    >
      <span className="inline-flex items-center rounded-sm transition-transform duration-300 group-hover:scale-[1.02]">
        <img
          src={LOGO_URL}
          alt={COMPANY.name}
          className="h-14 w-auto object-contain md:h-20"
        />
      </span>
    </button>
  );
};
